export class ReqModule { 
    constructor({moduleId, moduleName, items}) {
        this.moduleId = moduleId
        this.moduleName = moduleName
        this.items = items
    }

    fromJson(jsonDate) {
        this.moduleId = jsonDate.moduleId
        this.moduleName = jsonDate.moduleName
        this.items = jsonDate.items
    }
}

export class ReqModulePageList { 
    constructor({moduleId}) {
        this.moduleId = moduleId
    }

    fromJson(jsonDate) {
        this.moduleId = jsonDate.moduleId
    }
} 

export class ReqModulePage { 
    constructor({moduleId, pageId, pageName}) {
        this.moduleId = moduleId
        this.pageId = pageId
        this.pageName = pageName
    }

    fromJson(jsonDate) {
        this.moduleId = jsonDate.moduleId
        this.pageId = jsonDate.pageId
        this.pageName = jsonDate.pageName
    }
}

export class ReqModuleItem {
    constructor({ moduleId }) {
        this.moduleId = moduleId
    }

    fromJson(jsonData) {
        this.moduleId = jsonData.moduleId
    }
}

export class RespModuleItem {
    fromJson(jsonData){
        this.moduleId = jsonData.moduleId
        this.moduleName = jsonData.moduleName
        this.count = jsonData.count
        try {
            this.items = JSON.parse(jsonData.items) 
        } catch (error) {
            this.items = []
        }
    }
}